import { Component, Input } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { DashboardHighlightMetric } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-highlight-card',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './dashboard-highlight-card.component.html',
})
export class DashboardHighlightCardComponent {

  @Input({ required: true })
  public metric!: DashboardHighlightMetric;

}
